import React from 'react';
import { Link } from 'react-router-dom';

const YEAR = new Date().getFullYear();

const COL = [
  {
    title: 'Navigation',
    links: [
      { label: 'Accueil',      to: '/' },
      { label: 'Calendrier',   to: '/calendar' },
      { label: 'Standings F1', to: '/standings' },
      { label: 'Paddock',      to: '/paddock' },
    ],
  },
  {
    title: 'Box-Box',
    links: [
      { label: 'Tous les jeux',        to: '/box-box' },
      { label: 'LightSpeed',           to: '/lightspeed' },
      { label: 'CirQuiz',              to: '/quiz' },
      { label: 'PodiumQuiz',           to: '/podium' },
      { label: 'Champion de saison',   to: '/saison' },
    ],
  },
  {
    title: 'Mon compte',
    links: [
      { label: 'Connexion',    to: '/login' },
      { label: 'Inscription',  to: '/register' },
      { label: 'Mon profil',   to: '/profile' },
      { label: 'Mon pilote',   to: '/my-driver' },
    ],
  },
];

const LEGAL = [
  { label: 'Mentions légales',          to: '/legal' },
  { label: 'Politique de confidentialité', to: '/privacy' },
  { label: 'CGU',                        to: '/cgu' },
  { label: 'Contact',                    to: '/contact' },
];

const Footer = () => {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-900 mt-auto"
      style={{ borderTop: '2px solid #e10600' }}>

      {/* Main footer content */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand block */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img
                src="/logo-P1-blanc.png"
                alt="P1 or Not P1"
                className="h-10 w-auto object-contain"
              />
            </Link>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-xs">
              Le jeu de pronos F1 de ta bande. Prouve que t'as les yeux en face des courses.
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-f1red animate-pulse inline-block" />
              <span className="text-[11px] font-bold uppercase tracking-widest text-zinc-500">
                Saison 2026 · En cours
              </span>
            </div>
          </div>

          {/* Nav columns */}
          {COL.map(col => (
            <div key={col.title}>
              <h4 className="text-white text-xs font-black uppercase tracking-[0.2em] mb-4 flex items-center gap-2">
                <span className="w-3 h-px bg-f1red inline-block" />
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map(l => (
                  <li key={l.to}>
                    <Link to={l.to}
                      className="text-zinc-500 text-sm hover:text-white transition-colors hover:translate-x-0.5 inline-block">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-zinc-900">
        <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">

          {/* Legal links */}
          <nav className="flex flex-wrap items-center gap-x-4 gap-y-1 justify-center sm:justify-start">
            {LEGAL.map(l => (
              <Link key={l.to} to={l.to}
                className="text-zinc-600 text-xs hover:text-zinc-400 transition-colors">
                {l.label}
              </Link>
            ))}
          </nav>

          {/* Copyright */}
          <p className="text-zinc-600 text-xs text-center sm:text-right shrink-0">
            © {YEAR} P1 or Not P1 · Fait avec{' '}
            <span className="text-f1red">♥</span> par des fans F1
          </p>
        </div>

        {/* Disclaimer */}
        <div className="max-w-6xl mx-auto px-4 pb-5">
          <p className="text-zinc-700 text-[10px] leading-relaxed text-center">
            P1 or Not P1 est un projet non officiel, indépendant de la Formule 1, de la FIA ou de tout constructeur.
            Les noms, logos et marques Formula 1® appartiennent à leurs propriétaires respectifs.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
